import React from 'react';

export default function ProfileAddModal({
  activeModal,
  formData = {},
  onChange,
  onSave,
  onClose,
}) {
  if (!activeModal) return null;

  const titles = {
    family: 'Add Family Member',
    qualifications: 'Add Qualification',
    experience: 'Add Work Experience',
    skills: 'Add Skill',
    hobbies: 'Add Hobby',
    languages: 'Add Language',
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-xs">
      <div className="w-full max-w-lg rounded-2xl bg-surface-container-lowest shadow-2xl border border-outline-variant/25 overflow-hidden animate-in fade-in zoom-in-95 duration-150">
        {/* Modal Header */}
        <div className="flex items-center justify-between px-6 py-4 bg-primary text-white">
          <h3 className="text-sm font-bold tracking-wide">
            {titles[activeModal] || 'Add New Record'}
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="text-white/80 hover:text-white transition cursor-pointer"
          >
            <span className="material-symbols-outlined text-lg">close</span>
          </button>
        </div>

        {/* Modal Body */}
        <div className="p-6 space-y-4">
          {activeModal === 'family' && (
            <>
              <div className="flex flex-col gap-1">
                <label className="text-xs font-bold text-slate-700">Full Name</label>
                <input
                  type="text"
                  value={formData.fullName || ''}
                  onChange={(e) => onChange('fullName', e.target.value)}
                  placeholder="e.g. Vivek Singh"
                  className="rounded-xl border border-outline-variant/30 px-3.5 py-2 text-xs font-medium focus:border-primary focus:outline-none"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-xs font-bold text-slate-700">Qualification</label>
                <input
                  type="text"
                  value={formData.qualification || ''}
                  onChange={(e) => onChange('qualification', e.target.value)}
                  placeholder="e.g. Post Graduate"
                  className="rounded-xl border border-outline-variant/30 px-3.5 py-2 text-xs font-medium focus:border-primary focus:outline-none"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="flex flex-col gap-1">
                  <label className="text-xs font-bold text-slate-700">Contact Number</label>
                  <input
                    type="tel"
                    value={formData.contactNo || ''}
                    onChange={(e) => onChange('contactNo', e.target.value)}
                    placeholder="e.g. 9320388100"
                    className="rounded-xl border border-outline-variant/30 px-3.5 py-2 text-xs font-sans tabular-nums font-medium focus:border-primary focus:outline-none"
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <label className="text-xs font-bold text-slate-700">Age</label>
                  <input
                    type="number"
                    value={formData.age || ''}
                    onChange={(e) => onChange('age', e.target.value)}
                    placeholder="e.g. 52"
                    className="rounded-xl border border-outline-variant/30 px-3.5 py-2 text-xs font-sans tabular-nums font-medium focus:border-primary focus:outline-none"
                  />
                </div>
              </div>
            </>
          )}

          {activeModal === 'qualifications' && (
            <>
              <div className="flex flex-col gap-1">
                <label className="text-xs font-bold text-slate-700">Degree / Certificate</label>
                <input
                  type="text"
                  value={formData.degree || ''}
                  onChange={(e) => onChange('degree', e.target.value)}
                  placeholder="e.g. B.Tech Computer Science"
                  className="rounded-xl border border-outline-variant/30 px-3.5 py-2 text-xs font-medium focus:border-primary focus:outline-none"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-xs font-bold text-slate-700">Institution / University</label>
                <input
                  type="text"
                  value={formData.institution || ''}
                  onChange={(e) => onChange('institution', e.target.value)}
                  placeholder="e.g. Mumbai University"
                  className="rounded-xl border border-outline-variant/30 px-3.5 py-2 text-xs font-medium focus:border-primary focus:outline-none"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="flex flex-col gap-1">
                  <label className="text-xs font-bold text-slate-700">Passing Year</label>
                  <input
                    type="text"
                    value={formData.passingYear || ''}
                    onChange={(e) => onChange('passingYear', e.target.value)}
                    placeholder="e.g. 2024"
                    className="rounded-xl border border-outline-variant/30 px-3.5 py-2 text-xs font-sans tabular-nums font-medium focus:border-primary focus:outline-none"
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <label className="text-xs font-bold text-slate-700">Percentage / Grade</label>
                  <input
                    type="text"
                    value={formData.percentage || ''}
                    onChange={(e) => onChange('percentage', e.target.value)}
                    placeholder="e.g. 85%"
                    className="rounded-xl border border-outline-variant/30 px-3.5 py-2 text-xs font-sans tabular-nums font-medium focus:border-primary focus:outline-none"
                  />
                </div>
              </div>
            </>
          )}

          {activeModal === 'experience' && (
            <>
              <div className="flex flex-col gap-1">
                <label className="text-xs font-bold text-slate-700">Employer Organization</label>
                <input
                  type="text"
                  value={formData.employer || ''}
                  onChange={(e) => onChange('employer', e.target.value)}
                  placeholder="e.g. Acme Corp"
                  className="rounded-xl border border-outline-variant/30 px-3.5 py-2 text-xs font-medium focus:border-primary focus:outline-none"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-xs font-bold text-slate-700">Designation</label>
                <input
                  type="text"
                  value={formData.designation || ''}
                  onChange={(e) => onChange('designation', e.target.value)}
                  placeholder="e.g. Senior Developer"
                  className="rounded-xl border border-outline-variant/30 px-3.5 py-2 text-xs font-medium focus:border-primary focus:outline-none"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-xs font-bold text-slate-700">Duration / Experience</label>
                <input
                  type="text"
                  value={formData.duration || ''}
                  onChange={(e) => onChange('duration', e.target.value)}
                  placeholder="e.g. 2 Years"
                  className="rounded-xl border border-outline-variant/30 px-3.5 py-2 text-xs font-sans tabular-nums font-medium focus:border-primary focus:outline-none"
                />
              </div>
            </>
          )}

          {activeModal === 'skills' && (
            <>
              <div className="flex flex-col gap-1">
                <label className="text-xs font-bold text-slate-700">Skill Name</label>
                <input
                  type="text"
                  value={formData.skillName || ''}
                  onChange={(e) => onChange('skillName', e.target.value)}
                  placeholder="e.g. React & TypeScript"
                  className="rounded-xl border border-outline-variant/30 px-3.5 py-2 text-xs font-medium focus:border-primary focus:outline-none"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="flex flex-col gap-1">
                  <label className="text-xs font-bold text-slate-700">Proficiency Level</label>
                  <input
                    type="text"
                    value={formData.proficiency || ''}
                    onChange={(e) => onChange('proficiency', e.target.value)}
                    placeholder="e.g. Expert / Intermediate"
                    className="rounded-xl border border-outline-variant/30 px-3.5 py-2 text-xs font-medium focus:border-primary focus:outline-none"
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <label className="text-xs font-bold text-slate-700">Years</label>
                  <input
                    type="text"
                    value={formData.years || ''}
                    onChange={(e) => onChange('years', e.target.value)}
                    placeholder="e.g. 3 Years"
                    className="rounded-xl border border-outline-variant/30 px-3.5 py-2 text-xs font-sans tabular-nums font-medium focus:border-primary focus:outline-none"
                  />
                </div>
              </div>
            </>
          )}

          {activeModal === 'hobbies' && (
            <div className="flex flex-col gap-1">
              <label className="text-xs font-bold text-slate-700">Hobby Name</label>
              <input
                type="text"
                value={formData.name || ''}
                onChange={(e) => onChange('name', e.target.value)}
                placeholder="e.g. Chess, Reading, Cycling"
                className="rounded-xl border border-outline-variant/30 px-3.5 py-2 text-xs font-medium focus:border-primary focus:outline-none"
              />
            </div>
          )}

          {activeModal === 'languages' && (
            <>
              <div className="flex flex-col gap-1">
                <label className="text-xs font-bold text-slate-700">Language(s)</label>
                <input
                  type="text"
                  value={formData.language || ''}
                  onChange={(e) => onChange('language', e.target.value)}
                  placeholder="e.g. English, Hindi, German"
                  className="rounded-xl border border-outline-variant/30 px-3.5 py-2 text-xs font-medium focus:border-primary focus:outline-none"
                />
              </div>
              <div className="flex items-center gap-6 pt-2">
                <label className="inline-flex items-center gap-2 text-xs font-bold text-slate-700 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData.read || false}
                    onChange={(e) => onChange('read', e.target.checked)}
                    className="rounded border-outline-variant text-primary"
                  />
                  <span>Read</span>
                </label>
                <label className="inline-flex items-center gap-2 text-xs font-bold text-slate-700 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData.write || false}
                    onChange={(e) => onChange('write', e.target.checked)}
                    className="rounded border-outline-variant text-primary"
                  />
                  <span>Write</span>
                </label>
                <label className="inline-flex items-center gap-2 text-xs font-bold text-slate-700 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData.speak || false}
                    onChange={(e) => onChange('speak', e.target.checked)}
                    className="rounded border-outline-variant text-primary"
                  />
                  <span>Speak</span>
                </label>
              </div>
            </>
          )}
        </div>

        {/* Modal Footer */}
        <div className="flex items-center justify-end gap-3 px-6 py-4 bg-surface-container-low border-t border-outline-variant/20">
          <button
            type="button"
            onClick={onClose}
            className="rounded-xl px-4 py-2 text-xs font-bold text-slate-600 hover:bg-surface-container-high transition cursor-pointer"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onSave}
            className="rounded-xl bg-primary px-5 py-2 text-xs font-bold text-on-primary shadow-xs hover:bg-primary/90 transition cursor-pointer"
          >
            Save Entry
          </button>
        </div>
      </div>
    </div>
  );
}
